<template>
	<footer class="page-footer footer container">
		<p class="footer__copyright">© Общество с ограниченой ответственностью "SAAA"</p>
		<p class="footer__copyright">Зарегистрированный товарный знак SAA</p>
	</footer>
</template>

<script>
	export default {
		name: "Footer"
	}
</script>
